<form name="userProfileForm"
      (ngSubmit)="formSubmit()"
      [formGroup]="userProfileForm"
      novalidate>
  <div class="user-profile">
    <div class="container-fluid p-0"
         [ngClass]="{ 'content-loading-disabled': isLoader }">
      <!--<div class="loading-spinner-overlay" *ngIf="isLoader">
        <i class="fa fa-spinner fa-spin"></i>
      </div>-->
      <div class="bg-white p-4 mt-2">
        <div class="row">
          <div class="col-md-8 col-lg-9">
            <div class="title-wrap d-sm-flex">
              <div class="pr-2">
                <img [src]="logoImage" alt="logo Image" width="100" />
              </div>
              <div class="titles">
                <h6 class="ps-md-3 pt-2">
                  <small>
                    <ng-container *ngIf="userProfleModel?.stateName">
                      {{ userProfleModel.stateName }}
                    </ng-container>
                    <ng-container *ngIf="userProfleModel?.stateName && userProfleModel?.countryName">
                      ,
                    </ng-container>
                    <ng-container *ngIf="userProfleModel?.countryName">
                      {{ userProfleModel.countryName }}
                    </ng-container>
                  </small>
                </h6>

                <h3 class="ps-md-3">{{ userProfleModel?.organisation }}</h3>
                <!--<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>-->
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-8 col-xs-12">
                <div class="row">
                  <div class="col-lg-6 col-sm-6 col-xs-12">
                    <label class="col-form-label" for="address">Address</label>

                    <input type="text"
                           id="address"
                           class="form-control"
                           formControlName="address"
                           [ngClass]="{
                        'border border-danger ':
                          submitted &&
                          userProfileForm.hasError('required', 'address')
                      }" />
                        <span class="text-danger"
                              *ngIf="
                        submitted && userProfileForm.hasError('required', 'address')
                      ">
                      Address is required!
                    </span>
                  </div>

                  <div class="col-lg-6 col-sm-6 col-xs-12">
                    <label class="col-form-label" for="city">City/Suburb</label>

                    <input id="city"
                           class="form-control"
                           type="text"
                           formControlName="city"
                           [ngClass]="{
                    'border border-danger ':
                      submitted && userProfileForm.hasError('required', 'city')
                  }" />
                    <span class="text-danger"
                          *ngIf="
                    submitted && userProfileForm.hasError('required', 'city')
                  ">
                      City/Suburb is required!
                    </span>
                  </div>

                  <div class="col-lg-6 col-sm-6 col-xs-12">
                    <label class="col-form-label" for="stateName">State/Province</label>

                    <input type="text"
                           id="stateName"
                           class="form-control"
                           formControlName="stateName"
                           [ngClass]="{
                        'border border-danger ':
                          submitted &&
                          userProfileForm.hasError('required', 'stateName')
                      }" />
                                          <span class="text-danger"
                                                *ngIf="
                        submitted &&
                        userProfileForm.hasError('required', 'stateName')
                      ">
                      State/Province is required!
                    </span>
                  </div>

                  <div class="col-lg-6 col-sm-6 col-xs-12">
                    <label class="col-form-label" for="postCode">Post/Zip Code</label>

                    <input type="text"
                           id="postCode"
                           class="form-control"
                           formControlName="postCode"
                           [ngClass]="{
                    'border border-danger ':
                      submitted &&
                      userProfileForm.hasError('required', 'postCode')
                  }" />
                    <span class="text-danger"
                          *ngIf="
                    submitted &&
                    userProfileForm.hasError('required', 'postCode')
                  ">
                      Post/Zip Code is required!
                    </span>
                  </div>

                  <div class="col-lg-6 col-sm-6 col-xs-12">
                    <label class="col-form-label" for="countryName">Country</label>

                    <select *ngIf="countries.length > 0"
                            class="form-select"
                            id="basic-addon1"
                            formControlName="countryName"
                            [ngModelOptions]="{ standalone: true }"
                            [ngClass]="{
                        'border border-danger ':
                          submitted &&
                          userProfileForm.hasError('required', 'countryName')
                      }">
                      <option value="">Select Country...</option>
                      <option *ngFor="let country of countries"
                              value="{{ country?.countryName }}">
                        {{ country?.countryName }}
                      </option>
                    </select>

                    <span class="text-danger"
                          *ngIf="
                        submitted &&
                        userProfileForm.hasError('required', 'countryName')
                      ">
                      Country is required!
                    </span>
                  </div>

                </div>
              </div>

              <div class="col-md-4 col-xs-12">
                <div class="row">
                  <div class="col-lg-6 col-sm-6 col-xs-12">
                    <label class="d-block">Logo Image</label>
                    <div class="avatar-upload">
                      <div class="avatar-edit">
                        <input type="file"
                               id="logoImage"
                               accept=".png, .jpg, .jpeg"
                               #fileInput
                               (change)="uploadFile($event)" />
                      </div>
                      <div class="avatar-preview">
                        <img id="imagePreview" [src]="logoImage" />
                      </div>
                      <div class="closeBtn">
                        <label class="fa fa-camera btn-img"
                               (click)="fileInput.click()"
                               role="button"></label>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6 col-xs-12">
                    <label class="d-block">Hero Image</label>

                    <div class="avatar-header-upload">
                      <div class="avatar-edit">
                        <input type="file"
                               id="headerImage"
                               accept=".png, .jpg, .jpeg"
                               #headerFileInput
                               (change)="uploadHeaderFile($event)" />
                      </div>
                      <div class="avatar-preview">
                        <img id="headerImagePreview" [src]="headerImage" />
                      </div>
                      <div class="closeBtn">
                        <label class="fa fa-camera btn-img"
                               (click)="headerFileInput.click()"
                               role="button"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label" for="ClinicName">Clinic Name</label>

                <input id="ClinicName"
                       type="text"
                       class="form-control"
                       formControlName="organisation"
                       [ngClass]="{
                    'border border-danger ':
                      submitted &&
                      userProfileForm.hasError('required', 'organisation')
                  }" />
                <span class="text-danger"
                      *ngIf="
                    submitted &&
                    userProfileForm.hasError('required', 'organisation')
                  ">
                  Clinic Name is required!
                </span>
              </div>

              <div class="col-md-6">
                <label class="col-form-label" for="ClinicId">Clinic Id</label>
                <div>
                  <input id="ClinicId"
                         type="text"
                         class="form-control"
                         formControlName="organisationID" />
                </div>
              </div>

              <div class="col-md-6">
                <label class="col-form-label" for="email">Enquiry Email Address</label>

                <input type="email"
                       formControlName="enquiryEmailAddress"
                       id="email"
                       class="form-control" />

              </div>

              <div class="col-md-6">
                <label class="col-form-label" for="website">Website</label>

                <input id="websiteUrl"
                       type="text"
                       formControlName="websiteUrl"
                       class="form-control" />
              </div>
            </div>

            <hr />

            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label" for="phoneNumber">Office Phone 1</label>
                <ngx-intl-tel-input [cssClass]="'form-control'"
                                    [preferredCountries]="preferredCountries"
                                    [enableAutoCountrySelect]="true"
                                    [enablePlaceholder]="true"
                                    [searchCountryFlag]="true"
                                    [searchCountryField]="[
      SearchCountryField.Iso2,
      SearchCountryField.Name,
      SearchCountryField.DialCode
    ]"
                                    [selectFirstCountry]="false"
                                    [selectedCountryISO]="userProfileForm.get('selectedPNCountryISO')?.value"
                                    [maxLength]="15"
                                    [phoneValidation]="true"
                                    [separateDialCode]="true"
                                    [numberFormat]="PhoneNumberFormat.National"
                                    name="phoneNumber"
                                    required
                                    formControlName="phoneNumberControl">
                </ngx-intl-tel-input>
                <span class="text-danger"
                      *ngIf="
                    submitted &&
                   ( userProfileForm.hasError('required', 'phoneNumber') || userProfileForm.hasError('required', 'phoneNumberCountryCode') )
                  ">
                  Office Phone 1 is required!
                </span>
              </div>

              <div class="col-md-6">
                <label class="col-form-label" for="phoneNumber2">Office Phone 2</label>
                <ngx-intl-tel-input [cssClass]="'form-control'"
                                    [preferredCountries]="preferredCountries"
                                    [enableAutoCountrySelect]="true"
                                    [enablePlaceholder]="true"
                                    [searchCountryFlag]="true"
                                    [searchCountryField]="[
  SearchCountryField.Iso2,
  SearchCountryField.Name,
  SearchCountryField.DialCode
]"
                                    [selectFirstCountry]="false"
                                    [selectedCountryISO]="userProfileForm.get('selectedPN2CountryISO')?.value"
                                    [maxLength]="15"
                                    [phoneValidation]="true"
                                    [separateDialCode]="true"
                                    [numberFormat]="PhoneNumberFormat.National"
                                    name="phoneNumber2"
                                    formControlName="phoneNumber2Control">
                </ngx-intl-tel-input>
              </div>

              <div class="col-md-6">
                <label class="col-form-label" for="contactNumber1">Contact Number 1</label>
                <ngx-intl-tel-input [cssClass]="'form-control'"
                                    [preferredCountries]="preferredCountries"
                                    [enableAutoCountrySelect]="true"
                                    [enablePlaceholder]="true"
                                    [searchCountryFlag]="true"
                                    [searchCountryField]="[
  SearchCountryField.Iso2,
  SearchCountryField.Name,
  SearchCountryField.DialCode
]"
                                    [selectFirstCountry]="false"
                                    [selectedCountryISO]="userProfileForm.get('selectedCN1CountryISO')?.value"
                                    [maxLength]="15"
                                    [phoneValidation]="true"
                                    [separateDialCode]="true"
                                    [numberFormat]="PhoneNumberFormat.National"
                                    name="contactNumber1"
                                    formControlName="contactNumber1Control">
                </ngx-intl-tel-input>
              </div>

              <div class="col-md-6">
                <label class="col-form-label" for="contactNumber2">Contact Number 2</label>
                <ngx-intl-tel-input [cssClass]="'form-control'"
                                    [preferredCountries]="preferredCountries"
                                    [enableAutoCountrySelect]="true"
                                    [enablePlaceholder]="true"
                                    [searchCountryFlag]="true"
                                    [searchCountryField]="[
                      SearchCountryField.Iso2,
                      SearchCountryField.Name,
                      SearchCountryField.DialCode
                    ]"
                                    [selectFirstCountry]="false"
                                    [selectedCountryISO]="userProfileForm.get('selectedCN2CountryISO')?.value"
                                    [maxLength]="15"
                                    [phoneValidation]="true"
                                    [separateDialCode]="true"
                                    [numberFormat]="PhoneNumberFormat.National"
                                    name="contactNumber2"
                                    formControlName="contactNumber2Control">
                </ngx-intl-tel-input>
              </div>

              <!--<div class="col-md-6">
                <label class="col-form-label" for="DICOM">DICOM Device</label>

                <select class="form-select" id="DICOM" for="dicomDeviceId">
                  <option value="0">Some DICOM Option</option>
                </select>
              </div>-->
            </div>
            <!--<hr />
            <div class="row">
              <div class="col-12">
                <div class="form-group row mt-3">
                  <label for="trackingURL">Email Signature</label>
                  <div class="col-sm-12">
                    <div [ngxSummernote]="config" formControlName="emailSignature"></div>
                  </div>
                </div>
              </div>
            </div>-->
          </div>
        </div>

   <div class="row" *ngIf="!isLoader && isUseBuiltInSave">
          <div class="col-12 text-end pt-3">
            <button type="button"
                    class="btn btn-secondary me-2"
                    routerLink="/sales">
              <i class="fa fa-times"></i> Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-primary-color">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
